import qs from 'query-string';
import isEmpty from 'lodash/isEmpty';

type CustomURLParams = {
  [key: string]: string;
};

const withURLParams = (url?: string, customParams?: CustomURLParams[]) => {
  if (!url) return;

  const parsedURL = qs.parseUrl(url || '', { parseFragmentIdentifier: true });

  const formatURLParams = customParams?.reduce((previous, currentParam) => {
    const [currentParamKey] = Object.keys(currentParam);

    return {
      ...previous,
      [currentParamKey]: currentParam[currentParamKey],
    };
  }, {});

  const parsedURLParams = { ...parsedURL?.query, ...formatURLParams } || {};

  return `${parsedURL?.url}${!isEmpty(parsedURLParams) ? `?${qs.stringify(parsedURLParams)}` : ''}${
    parsedURL?.fragmentIdentifier ? `#${parsedURL?.fragmentIdentifier}` : ''
  }`;
};

export default withURLParams;
